import { render, staticRenderFns } from "./FeedbackQuestionIndex.vue?vue&type=template&id=c719b4de&scoped=true&"
import script from "./FeedbackQuestionIndex.vue?vue&type=script&lang=ts&"
export * from "./FeedbackQuestionIndex.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackQuestionIndex.vue?vue&type=style&index=0&id=c719b4de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c719b4de",
  null
  
)

export default component.exports